import ACNavigatorButton from 'academy-common-lib/components/navigation/contentNavigator/ACNavigatorButton';
import { getHumanizedDuration } from '../../utils/utils';
import { useMostRecentExamAttempt } from '../../features/exams';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getServerSyncedTime } from '../../utils/TimeUtils';
import { useTrackAwardProgress } from '../../features/userProgress';
import ExamTimer from '../../features/exams/components/ExamTimer';
import TrackViewAwardLink from '../TrackCard/TrackViewAwardLink';
import { List } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavigatorExamButton = ({
  active,
  trackId,
  language,
  duration,
  totalQuestions
}) => {
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading
  } = useMostRecentExamAttempt(trackId, language);
  const {
    award,
    allProgressLoading
  } = useTrackAwardProgress(trackId);
  if (mostRecentExamAttemptLoading || allProgressLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true
    });
  }
  const correctQuestionCount = mostRecentExamAttempt && mostRecentExamAttempt.score;
  const examIsRecent = mostRecentExamAttempt && getServerSyncedTime() - (mostRecentExamAttempt.attemptFinishTime || 0) < 24 * 60 * 60 * 1000;
  const certificationExpired = !examIsRecent && award && award.isExpired;
  return /*#__PURE__*/_jsx(ACNavigatorButton, {
    active: active,
    helpText: mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.passed && !certificationExpired ? /*#__PURE__*/_jsxs(List, {
      use: "inline-divided",
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.score",
        options: {
          correctQuestionCount,
          totalQuestionCount: totalQuestions
        }
      }), /*#__PURE__*/_jsx(TrackViewAwardLink, {
        award: award,
        certification: true,
        trackId: trackId,
        useButton: false
      })]
    }) : !(mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.passed) && mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.finished ? /*#__PURE__*/_jsxs(List, {
      use: "inline-divided",
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.score",
        options: {
          correctQuestionCount,
          totalQuestionCount: totalQuestions
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.failed"
      })]
    }) : mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.passed && certificationExpired ? /*#__PURE__*/_jsxs(List, {
      use: "inline-divided",
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.expired"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.failed"
      })]
    }) : mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.passed ? /*#__PURE__*/_jsx(ExamTimer, {
      language: language,
      passive: true,
      trackId: trackId
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.navigation.duration",
      options: {
        duration: getHumanizedDuration(duration, 'minutes')
      }
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.exam"
    }),
    to: `/tracks/${trackId}/exam`
  });
};
export default NavigatorExamButton;